import { FormLoginStyled } from "../../Styles/Login";
import LogoLogin from "../../Assets/Logos/logo_BRK.svg";
import LogoMobile from "../../Assets/Logos/logo_BRK.svg";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useContext, useState } from "react";
import { LoginContext } from "../../Context/ContextLogin";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

export const FormLogin = () => {
  const { confirmaLogin, carregando } = useContext(LoginContext);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const FormSchema = yup.object().shape({
    usuario: yup.string().required("Este campo é obrigatório*"),
    password: yup.string().required("Este campo é obrigatório*"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  const currentYear = new Date().getFullYear();

  return (
    <FormLoginStyled onSubmit={handleSubmit(confirmaLogin)}>
      <div className="formulario">
        <div className="logoLogin">
          <img className="logoDesktop" src={LogoLogin} alt="Logomarca SAE" />
          <img className="logoMobile" src={LogoMobile} alt="Logo Mobile" />
        </div>
        <div className="inputsLogin">
          <label>Usuário:</label>
          <input
            placeholder="Digite seu Nome:"
            type="text"
            {...register("usuario")}
          />
          {errors.usuario && <p>{errors.usuario.message}</p>}
        </div>
        <div className="inputsLogin">
          <label htmlFor="senha">Senha:</label>
          <div className="inputSenha">
            <input
              placeholder="Digite sua Senha:"
              type={mostrarSenha ? "text" : "password"}
              {...register("password")}
            />
            <button
              type="button"
              className="toggleSenha"
              onClick={() => setMostrarSenha(!mostrarSenha)}
            >
              {mostrarSenha ? <FaEye /> : <FaEyeSlash />}
            </button>
            {errors.senha && <p>{errors.senha.message}</p>}
          </div>
        </div>
        <div className="botaoEntrar">
          <button type="submit" disabled={carregando}>
            {carregando ? "Carregando..." : "ENTRAR"}
          </button>
        </div>
        <div className="compyright">
          <span>Copyright © ACLS Tecnologia 2024 - {currentYear}</span>
        </div>
      </div>
    </FormLoginStyled>
  );
};
